import React from 'react'
import { Trans } from '@lingui/macro'
import {
  ButtonDark,
  FilterCheckbox,
  Flex,
  HStack
} from 'front-end/src/components'
import { ActivityHistoryDateFiltersState } from '../activityHistoryTypes'

import { useLooopTheme } from '../../../public-api/hooks/useLooopTheme'
import { IconFilter } from '../../../components/common/icon/IconFilter'
import { DateRangeFilterModal } from '../../../components/common/date-range-filter-modal/DateRangeFilterModal'
import { getUserRangeTranslation } from '../../../components/utils/predefinedDateRanges'
import IconPencil from '../../../components/common/icon/IconPencil'
import { logActivityDateFilter } from '../activityHistoryUtils'
import { useCPDFeatureFlag } from 'front-end/src/app/hooks/useFeatureFlags'
import { useDisclosure } from '@chakra-ui/react'

interface ActivityHistoryFiltersProps extends ActivityHistoryDateFiltersState {
  isCpdOnlyFilter: boolean
  toggleCpdFilter: () => void
  isCpdEnabled: boolean
}

// TODO: Make it reusable
const ActivityHistoryFilter = ({
  dateFilters,
  setDateFilters,
  isCpdOnlyFilter,
  toggleCpdFilter,
  isCpdEnabled
}: ActivityHistoryFiltersProps) => {
  const { cpdAlias } = useCPDFeatureFlag()
  const { theme } = useLooopTheme()
  const disclosure = useDisclosure()

  const selectedDateRangeTranslations = React.useMemo(() => {
    return getUserRangeTranslation({
      selectedDateRangeItem: dateFilters.period,
      from: dateFilters.from,
      to: dateFilters.to
    })
  }, [dateFilters.from, dateFilters.to, dateFilters.period])
  return (
    <>
      <HStack spacing="24px" flexGrow={1}>
        <Flex
          flex={1}
          alignItems="center"
          bgColor={theme.colors.grey.lighter}
          borderRadius={theme.radii.base}
          ml="32px"
          p="0 16px"
          h="40px"
        >
          <Flex color={theme.colors.grey.mid} mr="16px">
            <IconFilter mr="4px" h="24px" w="auto" />
            <Trans>Showing</Trans>:
          </Flex>
          <ButtonDark
            size="sm"
            pl="10px"
            pr="10px"
            fontSize={theme.fontSizes.md}
            rightIcon={<IconPencil />}
            onClick={disclosure.onOpen}
            dataTest="DateFilter"
          >
            {selectedDateRangeTranslations}
          </ButtonDark>
        </Flex>
        {isCpdEnabled && (
          <FilterCheckbox
            toggleFilter={toggleCpdFilter}
            title={<Trans>Show {cpdAlias} Only</Trans>}
            isChecked={isCpdOnlyFilter}
          />
        )}
      </HStack>
      <DateRangeFilterModal
        isOpened={disclosure.isOpen}
        closeModal={disclosure.onClose}
        onFilterSubmit={({ from, to, period }) => {
          if (from && to) {
            logActivityDateFilter({
              from: from.toISOString(),
              to: to.toISOString()
            })
            setDateFilters({
              from,
              to,
              period
            })
          }
        }}
        {...dateFilters}
      />
    </>
  )
}

export default ActivityHistoryFilter
